const axios = require('axios');
import EventBus from '../api/event-bus.js';
import {errorHandler} from "./common";

export function getItemRequests(condition = '') {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/requestedItems?userId=0&stateFrom=-1&stateTo=5';
    if(condition.length > 0) {
      url += '&' + condition;
    }
    console.log("getItem list " + url);
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}

export function getItems(condition = '') {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/items?userId=0&stateFrom=-1&stateTo=5';
    if(condition.length > 0) {
      url += '&' + condition;
    }
    console.log("getItem list " + url);
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getRequestTypeString(requestType) {
  if(requestType === 'purchasing_agent') {
    return '구매/배송 대행';
  } else if(requestType === 'personal') {
    return '개인화물';
  } else if(requestType === 'ecommerce') {
    return '전자상거래';
  }
  return 'Unknown ' + requestType;
}
export function getCustomTypeString(customType) {
  if(customType === '목') {
    return '목록통관';
  } else if(customType === '일') {
    return '일반통관';
  } else if(customType === '간') {
    return '간이통관';
  }
  return customType;
}
export function getTradeTypeString(tradeType) {
  if(tradeType === 'A') {
    return '전자상거래';
  } else if(tradeType === 'C') {
    return '일반';
  }
  return tradeType;
}
export function getReceiverTypeString(receiverType) {
  if(receiverType === '1') {
    return '개인';
  } else if(receiverType === '2') {
    return '회사';
  }
  return receiverType;
}

export function convertItemState(state) {
  if(state == -1) {
    return "신청";
  }else if(state == 0) {
    return "준비";
  }
  return state;
}




// WEBPACK FOOTER //
// ./src/api/item.js